/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

var cn = ls.getSessionEventCollectionName();
const formRef = con.eventDB.collection(cn).doc('FormList').collection('Forms')
    //const storageRef = con.storageRef

export default {
    fetchForms({ commit }) {
        debugger;
        return new Promise((resolve, reject) => {
            const markers = []
            formRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    var data = doc.data();
                    if (data.FormType === 1) { data.FormTypeName = 'Poll' } else if (data.FormType === 2) { data.FormTypeName = 'Survey' } else if (data.FormType === 3) { data.FormTypeName = 'Form' } else { data.FormTypeName = '' }
                    //data.FormTypeName = this.getFormTypeNameById(data.FormType);
                    markers.push(data)
                })
                commit('SET_FORMS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting forms:', error)
                reject(error)
            })

        })
    },
    formTypes() {
        return [{ FormType: 1, FormTypeName: 'Poll' }, { FormType: 2, FormTypeName: 'Survey' }, { FormType: 3, FormTypeName: 'Form' }];
    },
    getFormTypeNameById(formType) {
        var allFormTypes = this.formTypes();
        var filteredTypes = allFormTypes.filter(function(value) {
            return value.FormType == formType;
        });
        if (filteredTypes.length > 0) {
            return filteredTypes[0].FormTypeName;
        } else {
            return '';
        }
    },
    //fetchFormsDropdown({ commit }) {
    //    return new Promise((resolve, reject) => {
    //        const markers = []
    //        formRef.get().then(querySnapshot => {

    //            querySnapshot.docs.forEach(doc => {
    //                markers.push({ TopicId: doc.data().TableId, TopicName: doc.data().TableName })
    //            })
    //            commit('SET_FORM_TYPES', markers)
    //            resolve(markers)
    //        }).catch(function(error) {
    //            //console.log('Error getting Form Types:', error)
    //            reject(error)
    //        })

    //    })
    //},
    fetchForm(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        MappedAttendees: [],
                        Host: [],
                        Occupied: 0,
                        CreatedByName: '',
                        CreatedDate: '',
                        SpectatorEnabled: true,
                        Capacity: 10,
                        CreatedByID: 0,
                        IsPublished: true,
                        //IsTableCreator:'',
                        LastModifiedDate: '',
                        TableId: '',
                        TableName: '',
                        Topic: { TopicId: 'RTT1591264542309', TopicName: 'General' },
                        //TopicId:'',
                        //TopicName:'',

                        TableType: 'Open',
                        Spectate: 'On',
                        PreAssignedType: 'Public'

                    }
                })
            } else {
                let docObj = new Object
                formRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                        //docObj.TableType = (doc.data().PreAssigned ? 'Pre_assigned' : 'Open')
                        //docObj.Spectate = doc.data().SpectatorEnabled

                    //console.log(docObj)                      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateForm(context, field) {
        //console.log(field)
        return new Promise((resolve, reject) => {
            formRef.doc(`${field.id}`).update({
                    TableName: field.data.TableName,
                    Capacity: field.data.Capacity,
                    Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                    PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                    SpectatorEnabled: field.data.Spectate,
                    MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                    CreatedByName: '',
                    CreatedByID: '',
                    IsPublished: field.data.IsPublished,
                    Topic: field.data.Topic,
                    LastModifiedDate: new Date()

                })
                .then(function(doc) {
                    if (field.data.Host.AttendeeId) {
                        let ParticipanceRef = formRef.doc(`${field.id}`).collection('Participances').doc(`${field.data.Host.AttendeeId}`)
                        ParticipanceRef.get().then(function(doc) {
                            if (!doc.exists) {
                                ParticipanceRef.set({
                                    AttendeeId: field.data.Host.AttendeeId,
                                    Name: field.data.Host.Name,
                                    FirstName: field.data.Host.FirstName,
                                    LastName: field.data.Host.LastName,
                                    ProfilePictureURL: field.data.Host.ProfilePictureURL,
                                    Designation: field.data.Host.Designation,
                                    IsActive: false,
                                    JoinTime: new Date(),
                                    LeaveTime: null,
                                    TableId: field.id,
                                    UserAgent: ''
                                })
                            } else {
                                ParticipanceRef.update({
                                    Name: field.data.Host.Name,
                                    FirstName: field.data.Host.FirstName,
                                    LastName: field.data.Host.LastName,
                                    ProfilePictureURL: field.data.Host.ProfilePictureURL,
                                    Designation: field.data.Host.Designation
                                        //IsActive: true,
                                        //JoinTime: new Date(),
                                        //LeaveTime: null,
                                        //TableId: AutoID,
                                        //UserAgent: ''
                                })
                            }
                        })
                    }
                    resolve({ status: 200, message: 'Data Updated.' })

                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    addForm(context, field) {
        //console.log(atob(field.id));
        //console.log(field); 
        //context.dispatch('getAutoId')
        return new Promise((resolve, reject) => {
            //let AutoID = "RT" + new Date().getTime();
            //let AutoID = context.dispatch('getAutoId');
            let docObj = {
                TableId: null,
                //AutoID: AutoID,
                TableName: field.data.TableName,
                Capacity: field.data.Capacity,
                Occupied: 0,
                Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                SpectatorEnabled: field.data.Spectate,
                MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                CreatedByName: field.data.CreatedByName,
                CreatedByID: field.data.CreatedByID,
                CreatedDate: new Date(),
                IsPublished: field.data.IsPublished,
                Topic: field.data.Topic,
                LastModifiedDate: new Date()
            }
            context.dispatch('getAutoId').then(AutoID => {
                docObj.TableId = AutoID;
                formRef.doc(`${AutoID}`).set(docObj).then(function() {
                    if (field.data.Host.AttendeeId) {
                        formRef.doc(`${AutoID}`).collection('Participances').doc(`${field.data.Host.AttendeeId}`).set({
                            AttendeeId: field.data.Host.AttendeeId,
                            Name: field.data.Host.Name,
                            FirstName: field.data.Host.FirstName,
                            LastName: field.data.Host.LastName,
                            ProfilePictureURL: field.data.Host.ProfilePictureURL,
                            Designation: field.data.Host.Designation,
                            IsActive: false,
                            JoinTime: new Date(),
                            LeaveTime: null,
                            TableId: AutoID,
                            UserAgent: ''
                        })
                    }

                    resolve({ status: 200, message: 'Data Added.', Id: field.data.TableId })
                }).catch(function(error) {
                    reject(error)
                })
            })


        })



    },
    //fetchRoundTableTopicDropdown({ commit }) {
    //    return new Promise((resolve, reject) => {
    //        const markers = []
    //        roundtabletopicRef.get().then(querySnapshot => {

    //            querySnapshot.docs.forEach(doc => {
    //                markers.push({ TopicId: doc.data().TopicId, TopicName: doc.data().TopicName })
    //            })
    //            commit('SET_ROUNDTABLETOPICS', markers)
    //            resolve(markers)
    //        }).catch(function(error) {
    //            //console.log('Error getting attendee:', error)
    //            reject(error)
    //        })

    //    })
    //},
    //addRoundtableTopic(context, field) {
    //    //console.log(atob(field.id));
    //    //console.log(field); 

    //    return new Promise((resolve, reject) => {
    //        let AutoID = "RTT" + new Date().getTime();
    //        let docObj = {
    //            CreatedBy: '',
    //            CreatedDate: new Date(),
    //            TopicId: AutoID,
    //            TopicName: field.TopicName,
    //            IsPrivate: true,
    //            LastModifiedDate: new Date()
    //        }

    //        //let nameMatched = false
    //        roundtabletopicRef.get().then(querySnapshot => {
    //            if (querySnapshot.size) {
    //                let namenotMatched = true
    //                querySnapshot.docs.forEach(doc => {
    //                    if (doc.data().TopicName.toLowerCase() == field.TopicName.toLowerCase()) {
    //                        namenotMatched = false
    //                    }
    //                })

    //                if (namenotMatched) {
    //                    roundtabletopicRef.doc(`${AutoID}`).set(docObj).then(function() {
    //                        resolve({ status: 200, message: 'Topic Added.' })
    //                    }).catch(function(error) {
    //                        //console.log(error)
    //                        reject(error)
    //                    })
    //                } else {
    //                    resolve({ status: 200, message: 'Topic Already Exist!.' })
    //                }

    //            } else {
    //                //console.log("not exist doc")
    //                roundtabletopicRef.doc(`${AutoID}`).set(docObj).then(function() {
    //                    resolve({ status: 200, message: 'Topic Added.' })
    //                }).catch(function(error) {
    //                    //console.log(error)
    //                    reject(error)
    //                })
    //            }
    //        }).catch(function(error) {
    //            reject(error)
    //                //console.log(error)
    //        })
    //    })
    //},
    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },
    removeRecord({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/user-management/users/${userId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', userId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    }
}